@if (alerts.length > 0) {
    @for (alert of alerts; track $index) {
        <ngb-alert [type]="alert.type" [dismissible]="alert.dismissible" [animation]="true" (closed)="close(alert)" role="alert">
            <i class="icon {{ iconClass(alert) }}" aria-hidden="true"></i>
            <div class="alert-content">
                @if (alert.heading) {
                    <div class="alert-heading">{{ alert.heading }}</div>
                    <div class="alert-message" innerHTML="{{ alert.message }}"></div>
                } @else {
                    <div class="alert-heading" innerHTML="{{ alert.message }}"></div>
                }
            </div>
        </ngb-alert>
    }
}
